



















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {throttle} from '@/utils';

const autocompleteThrottle = 500 // min time between API calls (ms)
@Component({})
export default class AutocompleteUser extends Vue {
  @Prop() public autocompleteFn!: (q: string) => Promise<any[]>
  @Prop() public autocompleteFor!: string
  @Prop() public value!: string
  @Prop({default: true}) public showValue!: boolean
  public pairedInput!: HTMLElement | null
  public af?: (s: string) => Promise<Promise<any[]>>
  public suggestions: { value: string, title: string }[] = []
  public left: number = 0
  public top: number = 0
  public width: number = 0

  public created() {
    this.af = throttle(this.autocompleteFn, autocompleteThrottle)
    this.pairedInput = document.getElementById(this.autocompleteFor)
  }

  public update(item: { value: string, title: string }) {
    this.$emit('update:value', item.value)
    this.$emit('selected', item)
  }

  private positionBox() {
    const input = document.getElementById(this.autocompleteFor)
    let rect: any
    if (input) {
      rect = input.getClientRects()[0]
      this.left = rect.x || rect.left
      this.top = rect.top + rect.height
      this.width = rect.width
    }
  }

  @Watch('value')
  async onInputChange(val: string) {
    this.positionBox()
    this.af && (this.suggestions = await this.af(val))
  }
}


